import React from "react";
import { useNavigate } from "react-router-dom";
import { ActionsFooter, CancelButton, SaveButton } from "./styles";
import { FiSave } from "react-icons/fi";

export default function ActionFooter({ onSave }) {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(-1); // 🔙 volta para a página anterior
  };

  return (
    <ActionsFooter>
      <CancelButton onClick={handleCancel}>
        Cancelar
      </CancelButton>

      <SaveButton onClick={onSave}>
        <FiSave style={{ marginRight: "8px" }} size={18} />
        Salvar
      </SaveButton>
    </ActionsFooter>
  );
}
